<template>
  <div class="navbar-container">
    <div class="fillerr" v-if="isHomePage"></div>

    <nav :class="[navbarClass, { 'homepage-rounded': isHomePage }]"
         :style="{ width: navbarWidth }">
      <div class="navbar-content">
        <!-- Logo -->
        <div class="logo">
          <router-link to="/">
            <img src="/TWConnLogo.png" alt="台灣聯通" />
          </router-link>
        </div>

        <!-- Navigation Links -->
        <ul class="nav-links" :class="{ 'mobile-active': isMobileMenuOpen }">
          <!-- Other nav links -->
          <!-- <li >
            <router-link to="/test-page">Test</router-link>
          </li> -->
          <li>
            <router-link to="/about">公司簡介</router-link>
          </li>
          <li>
            <router-link to="/UserApply" class="main-highlight">
              月票申辦
            </router-link>
          </li>
          <li>
            <router-link to="/parking-lots">停車場位置</router-link>
          </li>
          <li>
            <router-link to="/qna">問題Q&A</router-link>
          </li>
          <li>
            <router-link to="/offer-cards">信用卡優惠</router-link>
          </li>
          <li>
            <router-link to="/collaboration-page">委託與合作</router-link>
          </li>
          <li>
            <router-link to="/parking-sale">出售車位</router-link>
          </li>
          <li>
            <router-link to="/quick-pass">快速通</router-link>
          </li>

          <!-- 月票與會員 Dropdown -->
          <li
            @mouseover="showDropdown('monthTicket')"
            @mouseleave="hideDropdown"
          >
            <!-- Desktop hover version (only for wide screens) -->
            <span
              v-if="!isMobileMenuOpen"
              class="disabled-link nav-link-with-icon"
            >
              月票與會員
              <svg
                class="chevron-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 6"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>

            <!-- Mobile click version (for small screens) -->
            <router-link
              v-else
              to="#"
              @click.prevent="toggleDropdown('monthTicket')"
              :class="['nav-link-with-icon', { active: isMonthTicketOpen }]"
            >
              月票與會員
              <svg
                class="chevron-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 6"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>

            <!-- Dropdown Menu -->
            <div
              v-if="isMonthTicketOpen && !isMobileMenuOpen"
              class="dropdown"
            >
              <router-link v-if="!user" to="/UserRegister">會員註冊</router-link>
              <router-link to="/UserApply">月票申辦</router-link>
              <router-link to="/UserRecord">月票登記抽籤</router-link>
              <router-link to="/UserCancel">退租登記</router-link>
              <router-link v-if="user" to="/month-ticket-bill">月票繳費</router-link>
              <router-link v-if="user" to="/lpboard">會員車號登記</router-link>

            </div>
          </li>

          <!-- 臨停線上繳費 Dropdown -->
          <li
            v-if="user"
            @mouseover="showDropdown('onlinePayment')"
            @mouseleave="hideDropdown"
          >
            <!-- Desktop hover version -->
            <span
              v-if="!isMobileMenuOpen"
              class="disabled-link nav-link-with-icon"
            >
              臨停線上繳費
              <svg
                class="chevron-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 6"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>

            <!-- Mobile click version -->
            <router-link
              v-else
              to="#"
              @click.prevent="toggleDropdown('onlinePayment')"
              :class="['nav-link-with-icon', { active: isOnlinePaymentOpen }]"
            >
              臨停線上繳費
              <svg
                class="chevron-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 6"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

            </router-link>

            <!-- Dropdown Menu -->
            <div
              v-if="isOnlinePaymentOpen && !isMobileMenuOpen"
              class="dropdown"
            >
              <router-link to="/OnlinePayment">臨停線上繳費</router-link>
              <router-link v-if="user" to="/cardboard">紅利折抵卡片登記</router-link>

            </div>
          </li>

          <!-- If user not logged in, show direct link -->
          <li v-else>
            <router-link to="/OnlinePayment">臨停線上繳費</router-link>
          </li>

          <!-- Other links, login/logout, etc. -->
          <li>
            <router-link to="/recruitment-page">人才招募</router-link>
          </li>

          <!-- 宜蘭路邊停車 Dropdown -->
          <li
            @mouseover="showDropdown('yilanParking')"
            @mouseleave="hideDropdown"
          >
            <!-- Desktop hover version -->
            <span
              v-if="!isMobileMenuOpen"
              class="disabled-link nav-link-with-icon"
            >
              宜蘭路邊停車
              <svg
                class="chevron-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 6"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>

            <!-- Mobile click version -->
            <router-link
              v-else
              to="#"
              @click.prevent="toggleDropdown('yilanParking')"
              :class="['nav-link-with-icon', { active: isYilanParkingOpen }]"
            >
              宜蘭路邊停車
              <svg
                class="chevron-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 6"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </router-link>

            <!-- Dropdown Menu -->
            <div
              v-if="isYilanParkingOpen && !isMobileMenuOpen"
              class="dropdown"
            >
              <router-link to="/disability-parking">身障優惠登記</router-link>
            </div>
          </li>

          <li v-if="loginButtonProps.isLogout" class="desktop-element">
            <router-link
              :to="loginButtonProps.link"
              :class="{ 'btn-login': loginButtonProps.isButton }"
              @click="attemptLogout"
            >
              {{ loginButtonProps.text }}
            </router-link>
          </li>
          <li v-else class="desktop-element">
            <router-link
              :to="loginButtonProps.link"
              :class="{ 'btn-login': loginButtonProps.isButton }"
            >
              {{ loginButtonProps.text }}
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AppNavbar',
  data() {
    return {
      isHomePage: false,
      isMobileMenuOpen: false,

      // Single property for dropdown
      // Acceptable values: 'monthTicket', 'onlinePayment', or null
      openDropdown: null,
    };
  },
  computed: {
    ...mapGetters(['user']),

    navbarClass() {
      return this.isHomePage ? 'navbar homepage-navbar' : 'navbar';
    },
    navbarWidth() {
      return this.isHomePage ? '94.17vw' : '99.9%';
    },
    // Optional: if you still need a top margin.
    navbarTopMargin() {
      return this.isHomePage ? '56px' : '0';
    },
    loginButtonText() {
      return this.user ? `${this.user} 登出` : '會員登入';
    },
    loginButtonProps() {
      return {
        text: this.loginButtonText,
        link: '/login-page',
        isButton: true,
        isLogout: !!this.user,
      };
    },

    // Helper to check if the "monthTicket" dropdown is open
    isMonthTicketOpen() {
      return this.openDropdown === 'monthTicket';
    },
    // Helper to check if the "onlinePayment" dropdown is open
    isYilanParkingOpen() {
      return this.openDropdown === 'yilanParking';
    },

    isOnlinePaymentOpen() {
      return this.openDropdown === 'onlinePayment';
    },
  },
  methods: {
    ...mapActions(['logout']),
    async attemptLogout() {
      try {
        await this.logout();
        console.log('登出成功');
        this.$router.push('/');
      } catch (error) {
        console.error('登出失敗:', error);
      }
    },

    // Show the named dropdown
    showDropdown(name) {
      this.openDropdown = name;
    },
    // Hide all dropdowns
    hideDropdown() {
      this.openDropdown = null;
    },
    // Toggle a specific dropdown
    toggleDropdown(name) {
      if (this.openDropdown === name) {
        this.openDropdown = null;
      } else {
        this.openDropdown = name;
      }
    },
  },
  watch: {
    $route(to) {
      this.isHomePage = to.path === '/';
      // Close any open dropdown on route change
      this.isMobileMenuOpen = false;
      this.openDropdown = null;
    },
  },
  mounted() {
    this.isHomePage = this.$route.path === '/';
  },
};
</script>


<style scoped>
.navbar-shadow {
  height: 88px;
  background-color: transparent;
}

.fillerr {
  height: 56px;
  /* 88px */
  /* color:red; */
  background-color: transparent;
  /* color: transparent; */
}

.navbar-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  background-color: transparent;
  /* box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1); */
  top: 0;
  z-index: 1000;
  /* height: 5.5rem; 88px */
  /* border: 0.0625rem solid #f1f1f1; 1px */
  position: absolute;
  /* box-sizing: border-box; */
  width: 100%;
  margin: 0, auto;

}

.navbar {
  display: flex;
  justify-content: center;
  padding: 0;
  /* background-color: white; */
  background-color: white;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
  /* top: 0; */
  /* z-index: 1000; */
  height: 5.5rem;
  /*88px */
  border: 0.0625rem solid #f1f1f1;
  /* 1px */
  /* position: absolute; */
  box-sizing: border-box;
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: calc(100% - 3rem);
  /* 48px */
  padding: 0 1.5rem;
  /* 24px */
  font-size: 1rem;
  /* 16px */
  font-family: 'Noto Sans TC', sans-serif;
  font-weight: 700;
}

.homepage-rounded {
  border-radius: 0.5rem;
  /* 8px */
}



.logo img {
  height: 3.5rem;
  /* 56px */
  margin-top: 0.625rem;
  /* 10px */
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease;
}

.nav-links li {
  margin-left: 1.5rem;
  /* 24px */
  position: relative;
}

.nav-links a,
.disabled-link {
  text-decoration: none;
  color: var(--green03);
  font-size: 1rem;
  /* 16px */
  white-space: nowrap;
}

.disabled-link {
  cursor: default;
  user-select: none;
}

.btn-login {
  background-color: var(--green03);
  color: white !important;
  padding: 0.6875rem 1.375rem;
  /* 11px 22px */
  border-radius: 6.1875rem;
  /* 99px */
  text-decoration: none;
}

.nav-link-with-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
}


.chevron-icon {
  width: 1rem;
  /* 16px */
  height: 0.4375rem;
  /* 7px */
  margin-left: 0.125rem;
  /* 2px */
  margin-top: 0.125rem;
  /* 2px */
  transition: transform 0.3s ease;
  stroke: var(--green03);
}

.nav-link-with-icon.active .chevron-icon {
  transform: rotate(180deg);
}

.nav-link-with-icon:hover .chevron-icon {
  stroke: var(--primary-green);
}

.dropdown {
  position: absolute;
  top: 100%;
  left: -1rem;
  /* -16px */
  background-color: white;
  border-radius: 0.5rem;
  /* 8px */
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  padding: 0.625rem;
  /* 10px */
  width: 9rem;

  color : var(--green03);
  /* 144px */
}

.dropdown a {
  padding: 0.625rem 0.9375rem;
  /* 10px 15px */
  text-decoration: none;
  font-size: 1rem;
  /* 16px */
  color: var(--primary-green);
}

.dropdown a:hover {
  background-color: #f1f1f1;
}

@media (min-width: 1090px) and (max-width: 1260px) {
  /* 810px to 1000px */

  .navbar-shadow {
    height: 3.5rem;
    /* 56px */
  }

  .navbar {
    height: 3.5rem;
    /* 56px */
  }



  .fillerr {
    height: 40px;
  }

  .navbar-content {
    padding: 0 1rem;
    /* 16px */
  }

  .logo img {
    height: 2.5rem;
    /* 40px */
    margin-top: 0.5rem;
    /* 8px */
  }

  .nav-links li {
    margin-left: 1rem;
    /* 16px */
  }

  .nav-links a,
  .disabled-link {
    font-size: 0.875rem;
    /* 14px */
    margin-top: 0.15625rem;
    /* 2.5px */
  }

  .btn-login {
    padding: 0.625rem 1.25rem;
    /* 10px 20px */
  }

  .chevron-icon {
    width: 0.875rem;
    /* 14px */
    height: 0.375rem;
    /* 6px */
  }

  .dropdown {
    padding: 0.5rem;
    /* 8px */
    width: 7.5rem;
    /* 120px */
  }

  .dropdown a {
    padding: 0.5rem 0.75rem;
    /* 8px 12px */
    font-size: 0.875rem;
    /* 14px */
  }
}

@media (max-width: 1089px) {
  /* 809px */

  .navbar-shadow {
    height: 3rem;
    /* 48px */
  }

  .navbar {
    height: 3rem;
    /* 48px */
  }

  .fillerr {
    height: 24px;
  }

  .navbar-content {
    padding: 0 0.375rem;
    /* 6px */
  }

  .logo img {
    height: 1.25rem;
    /* 20px */
    /* margin-top: 0.375rem; 6px */
    margin-top: 0.475rem;
    /* 6px */
  }

  .nav-links li {
    margin-left: 0.375rem;
    /* 6px */
  }

  .nav-links a,
  .disabled-link {
    font-size: 0.75rem;
    /* 12px */
    margin-top: 0.28125rem;
    /* 4.5px */
  }

  .btn-login {
    padding: 0.5rem 1rem;
    /* 8px 16px */
  }

  .chevron-icon {
    width: 0.75rem;
    /* 12px */
    height: 0.3125rem;
    /* 5px */
  }

  .dropdown {
    padding: 0.375rem;
    /* 6px */
    width: 6.25rem;
    /* 100px */
  }

  .dropdown a {
    padding: 0.375rem 0.625rem;
    /* 6px 10px */
    font-size: 0.75rem;
    /* 12px */
  }
}
</style>